export default {
  DISPLAY_AS: {
    TEXT_INPUT: 'text-input',
    BOOLEAN: 'boolean',
    TIME_ZONE_SELECT: 'time-zone-select',
    SUB_HEADING: 'sub-heading',
    ADD_GRID_RESOURCE: 'add-grid-resource',
    RESOURCE: 'resource',
    GRID: 'grid',
    PAGING_GRID: 'paging-grid',
    TAG_INPUT: 'tag-input',
    SELECT: 'select',
    KEY_VALUE_PAIRS: 'key-value-pairs',
    POINTS_OF_INTEREST: 'points-of-interest',
    COMPANY_REFERENCE: 'company-reference',
    SEARCH_BY: 'search-by',
    FILE_UPLOADER: 'file-uploader',
    COUNTRY_SELECT: 'country-select',
    BOOLEAN_RESTRICTION_SELECT: 'boolean-restriction-select',
    FARE_CLASS_TYPE_SELECT: 'fare-class-type-select',
    TEXT_AREA: 'text-area',
    MULTI_SELECT: 'multi-select',
    GROUP: 'group',
    TABS: 'tabs',
    LAT_LONG_MAP_SEARCH: 'lat-long-map-search',
    HOTEL: 'hotel',
    LAT_LNG_MAP: 'lat-lng-map',
    RANGE: 'range',
    O_DATA_SELECT: 'o-data-select',
    HOTEL_TAG_SELECT: 'hotel-tag-select',
    FILE_DOWNLOADER: 'file-downloader',
    VIEW_GRID: 'view-grid',
    DATE_PICKER: 'date',
    PER_DIEM: 'per-diem',
    PER_DIEM_GRID_ITEM: 'per-diem-grid-item',
    PER_DIEM_FILE_UPLOADER: 'per-diem-file-uploader',
    TEST_FTP_CONNECTION: 'test-ftp-connection',
    ENHANCED_LOG_ITEM: 'enhanced-log-item',
    COMPANY_REFEREENCE_AUDIT_ITEM: 'company-reference-config-audit-item'
  },
  MICRO_SERVICE: {
    DEBTORS: 'debtors',
  },
  DATA_SOURCES: {
    ODATA: 'odata',
    AUTH_ZERO: 'auth0'
  },
  PRODUCT_FAMILY: {
    LB: 'Lightning Book',
    CTM: 'CTM',
    SupplierRelations: 'Supplier Relations'
  },
  FIELDS: {
    ENHANCEDPOLICYRULES: 'EnhancedPolicyRules',
    ENHANCEDPOLICYRULEACTIONS: 'Actions'
  },
  MESSAGES:{
    NDC_TIE_SETTINGS:"<i title='For example if type NDC is selected and threshold is 0. Then Atpco will be shown unless the NDC fare is less then the Atpco.'>The selected type will only be used if the savings is greater than the defined threshold</i>"
  }
}


// WEBPACK FOOTER //
// ./src/config/constants.js